"use client";
import Table, { ColumnDef } from "@/components/primitives/table";
import { removeLeadingZeroDecimal } from "@/utils";
import { truncateName } from "@/utils/injuries";
import { createPlayerProfileSlug } from "@/utils/url";
import { GoaltenderStats, Sport } from "common";
import Link from "next/link";
import React from "react";

export default function GoaltenderComparisonTable({
  data,
  sport,
}: {
  data: GoaltenderStats[];
  sport: Sport;
}) {
    const columns: ColumnDef<GoaltenderStats>[] = React.useMemo(
        () => [
          {
            header: "name",
            width: "128px",
            accessorFn: (info) => {
                return `${truncateName(info.firstName)} ${info.lastName}`;
            },
            enableSorting: false,
            cell: (info) => {
              return (
                <Link
                  href={createPlayerProfileSlug(sport, info.row.original.id)}
                >
                  {`${info.getValue()}`}
                </Link>
              );
            },
          },
          {
            header: "w/l/ot",
            accessorFn: (info) => {
                return `${info.wins}-${info.losses}-${info.overtimeLosses}`;
            },
            enableSorting: false,
          },
          {
            header: "ga/g",
            accessorKey: "goalsAgainstPerGame",
            enableSorting: false,
          },
          {
            header: "sv%",
            accessorFn: (info) => {
              return `${removeLeadingZeroDecimal(info.savePct)}`;
          },
            enableSorting: false,
          },
        ],
        []
      );
      return <Table columns={columns} data={data} type="banded" />;
}
